import LogoPanel from './LogoPanel';
import styled from 'styled-components';

const Header = styled.div`
  font-family: Rubik, sans-serif !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  margin-top: 40px;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  font-size: 18px;
  line-height: 1.25;
  color: #1e4e5f;
`;

const Text = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  margin-top: 20px;
  padding-left:40px;
  padding-right:40px;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: var(--dark-slate-blue);
`;

export { Header, LogoPanel, Text };
